import LookupTableConstants from "@/components/membership/ChooseFormulaModal/lookupForm/LookupUtils/LookupTableConstants";

function LookupTableUtils() {
  function getEmptyLookupColumnsArray() {
    // the form should start with just one drop down for affiliate data
    // we want this dynamically generated so that future devs only have to change this in one place which is the above properties
    const tempArr = [],
      { MIN_COLS, blankLookupColumnValue } = LookupTableConstants;

    for (let i = 0; i < MIN_COLS - 1; i++) {
      tempArr.push(blankLookupColumnValue);
    }
    return tempArr;
  }

  function getEmptyLookupTable() {
    // the form should start with two rows for formula data
    // we want this dynamically generated so that future devs only have to change this in one place which is the above properties
    const tempArr = [],
      { MIN_ROWS, MIN_COLS, blankFormulaDataValue } = LookupTableConstants;

    for (let i = 0; i < MIN_ROWS; i++) {
      const innerTempArray = [];
      for (let j = 0; j < MIN_COLS; j++) {
        innerTempArray.push(blankFormulaDataValue);
      }
      tempArr.push(innerTempArray);
    }

    return tempArr;
  }

  function lookupTableContainsDuplicateRows(data) {
    const uniqueRows = new Set();

    for (const row of data) {
      const rowString = row.join();
      if (uniqueRows.has(rowString)) {
        return true;
      }
      uniqueRows.add(rowString);
    }
    return false;
  }

  function determineIfRowsMatchExceptFinalEntry(arr) {
    const answer = [];
    for (let i = 0; i < arr.length; i++) {
      const arr1 = arr[i];
      for (let j = i + 1; j < arr.length; j++) {
        const arr2 = arr[j];
        for (let k = 0; k < arr1.length; k++) {
          if (k === arr1.length - 1) {
            if (arr1[k] !== arr2[k]) {
              answer.push([i, j]);
            }
          } else if (arr1[k] !== arr2[k]) {
            break;
          }
        }
      }
    }
    return answer;
  }

  function addRow(arr_arg) {
    const { blankFormulaDataValue } = LookupTableConstants;
    const alteredTable = [
      ...arr_arg,
      Array(arr_arg[0].length).fill(blankFormulaDataValue),
    ];
    return alteredTable;
  }

  function deleteRow(arr_arg) {
    const { MIN_ROWS } = LookupTableConstants;
    return arr_arg.length > MIN_ROWS ? arr_arg.slice(0, -1) : arr_arg;
  }

  function addColumn(arr_arg) {
    const { blankFormulaDataValue, MAX_COLS } = LookupTableConstants;
    return arr_arg.map((arr) =>
      arr.length < MAX_COLS
        ? arr.toSpliced(arr.length - 1, 0, blankFormulaDataValue)
        : arr
    );
  }

  function deleteColumn(arr_arg) {
    const { MIN_COLS } = LookupTableConstants;
    return arr_arg.map((arr) =>
      arr.length > MIN_COLS ? arr.toSpliced(arr.length - 1, 1) : arr
    );
  }

  function addHeader(arr_arg, current_headers) {
    const { MAX_COLS, blankLookupColumnValue } = LookupTableConstants;

    return arr_arg[0] && arr_arg[0].length < MAX_COLS
      ? [...current_headers, blankLookupColumnValue]
      : current_headers;
  }

  function deleteHeader(arr_arg, current_headers) {
    return arr_arg[0].length > 2
      ? current_headers.slice(0, -1)
      : current_headers;
  }

  function removeUnpermittedOutputs(formulaData, permittedOutputs) {
    const { blankFormulaDataValue } = LookupTableConstants;
    return formulaData.map((arr) => {
      const tempArray = [...arr];
      const finalItem = tempArray[tempArray.length - 1];
      if (!permittedOutputs.includes(finalItem)) {
        tempArray[tempArray.length - 1] = blankFormulaDataValue;
      }
      return tempArray;
    });
  }

  function arrayOverlap(arr1, arr2) {
    return !!arr1.find((item) => arr2.includes(item));
  }

  return {
    getEmptyLookupColumnsArray,
    getEmptyLookupTable,
    lookupTableContainsDuplicateRows,
    determineIfRowsMatchExceptFinalEntry,
    addRow,
    deleteRow,
    addColumn,
    deleteColumn,
    addHeader,
    deleteHeader,
    removeUnpermittedOutputs,
    arrayOverlap,
  };
}
export default LookupTableUtils;
